import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import BigCalendar from 'react-big-calendar';
import StatusTag from 'components/ui/StatusTag';
import { MaintenanceTicketPriority } from 'components/shared/StatusHelper';
import moment from 'moment';
import { getTranslatedString } from 'helpers/i18n';

let eventSource = {
  beginDrag(props) {
    return {
      event: {
        id: props.ticket.id,
        title: props.ticket.subject,
      },
      anchor: 'drop',
    };
  },
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

class UnscheduledTicket extends Component {
  propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    event: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  styles = {
    task: {
      background: 'rgb(248, 248, 248)',
      border: '1px solid rgba(128, 128, 128, 0.3)',
      padding: '0.5rem',
      marginBottom: '0.5rem',
      borderRadius: '2px',
      cursor: 'pointer',
    },
    caption: {
      fontSize: '12px',
      color: 'rgba(0,0,0,0.4)',
    },
  };

  render() {
    let { connectDragSource, bgColor, fgColor, captionColor, ticket } = this.props;
    let EventWrapper = BigCalendar.components.eventWrapper;

    let stylesClone = JSON.parse(JSON.stringify(this.styles));
    stylesClone.task.background = bgColor;
    stylesClone.task.color = fgColor;
    stylesClone.caption.color = captionColor;

    return (
      <EventWrapper ref={this.props.ref}>
        {connectDragSource(
          <div draggable style={stylesClone.task} onClick={() => this.props.goToTicket(ticket.id)}>
            <div>
              {ticket.ticket_number}. {ticket.subject}
              <StatusTag status={ticket.status} leftMargin={'5px'} display={'inline'} />
            </div>
            <div style={stylesClone.caption}>
              {this.renderUnitIfAny()}
              {this.renderRoomIfAny()}
              {this.renderAssetIfAny()}
              <MaintenanceTicketPriority priority={ticket.priority} />{' '}
              {getTranslatedString('landlordPortal.landlordTicketScheduler.priority')} <br />
              {moment(ticket.request_date).fromNow()} <br />
            </div>
          </div>
        )}
      </EventWrapper>
    );
  }

  renderUnitIfAny = () => {
    if (this.props.ticket.unit_id === null) return null;
    return (
      <div>
        {getTranslatedString('landlordPortal.landlordTicketScheduler.unit')}{' '}
        {this.props.ticket.unit_number}
        <br />
      </div>
    );
  };
  renderRoomIfAny = () => {
    if (this.props.ticket.room_id === null) return null;
    return (
      <div>
        {getTranslatedString('landlordPortal.landlordTicketScheduler.room')}:{' '}
        {this.props.ticket.room_name}
        <br />
      </div>
    );
  };
  renderAssetIfAny = () => {
    if (this.props.ticket.maintenance_asset_id === null) return null;
    return (
      <div>
        {getTranslatedString('landlordPortal.landlordTicketScheduler.asset')}:{' '}
        {this.props.ticket.asset_name}
        <br />
      </div>
    );
  };
}

export default DragSource('event', eventSource, collectSource)(UnscheduledTicket);
